import { Deserializable } from './deserializable.model';

export class LocalFirstVisit implements Deserializable<any, LocalFirstVisit> {
  constructor(public clearedIoNotifications = false, public notificationPrompt = false, public reminders = false) {}

  deserialize(json?: any, previousValue?: LocalFirstVisit): LocalFirstVisit {
    if (json != null || previousValue != null) {
      Object.assign(this, previousValue || {}, json);
    }
    return this;
  }
}
